import PropTypes from 'prop-types';
import StaticResponsiveHeaderBanner from './StaticResponsiveHeaderBanner';
import HeaderBannerWithCollapsableContent from './HeaderBannerWithCollapsableContent';
import HeaderBannerWithSlider from './HeaderBannerWithSlider';

export default function HeaderBanner(props) {

  if (props.htmlContent) {
    if (props.htmlContent.includes('<div id="collapsable-content">')) {
      return <HeaderBannerWithCollapsableContent {...props} />;
    }

    if (props.htmlContent.includes('class="dc-tabbed-slider') ||
      props.htmlContent.includes('class="dc-slider')
    ) {
      return <HeaderBannerWithSlider {...props} />;
    }

    return <StaticResponsiveHeaderBanner {...props} />;
  }

  return null;
}

HeaderBanner.displayName = 'HeaderBanner';

HeaderBanner.propTypes = {
  htmlContent: PropTypes.string
};

HeaderBanner.defaultProps = {
  htmlContent: null
};
